module.exports = "/assets/b6a241857a92b1c86be2fe9d58a1aabf.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/BN.png
// module id = 1236
// module chunks = 0